import { Box, Grid } from "@material-ui/core";
import * as React from "react";
import { useMatchesMdDown, useMatchesXsDown } from "../../../hooks";
import SocialHandles from "../../SocialHandles";
import UpcomingSignings from "../../UpcomingSignings";

const ShopSideDetails = React.memo(function ShopSideDetails({ influencer }) {
  const matchesMd = useMatchesMdDown();
  const matchesXs = useMatchesXsDown();

  const { influencerId, handles } = influencer;

  const boxPadding = matchesMd ? 0 : 5;

  return (
    <Box pt={boxPadding} pb={matchesXs ? 0 : 1}>
      <Grid
        container
        spacing={2}
        direction={matchesXs ? "column-reverse" : "column"}
      >
        {influencer.showEvents && (
          <Grid item xs={12}>
            <UpcomingSignings
              influencerId={influencerId}
              isGroupShop={influencer.isGroupShop}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <SocialHandles handles={handles?.list ?? []} />
        </Grid>
      </Grid>
    </Box>
  );
});

export default ShopSideDetails;
